<template>
  <footer class="footer-section">
    <div class="footer-main">
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-brand">
            <div class="footer-logo">
              <img src="@/assets/berts-logo-footer.svg" alt="BERT Points" class="footer-logo-img" />
            </div>
            <div class="footer-icon">
              <img src="@/assets/bert-icon-footer.png" alt="BERT Icon" class="footer-icon-img" />
            </div>
          </div>
          
          <div class="footer-links">
            <div class="footer-column">
              <h4 class="footer-column-title">Links</h4>
              <router-link to="/" class="footer-link">Beranda</router-link>
              <router-link to="/komunitas" class="footer-link">Komunitas Kami</router-link>
              <router-link to="/benefit" class="footer-link">Benefit Bert Points</router-link>
              <a href="/faq" class="footer-link">FAQ</a>
              <router-link to="/kebijakan-privasi" class="footer-link">Kebijakan Privasi</router-link>
            </div>
            
            <div class="footer-column">
              <h4 class="footer-column-title">Partner with us!</h4>
              <div class="footer-contact">
                <a href="https://wa.me/628115674433" class="contact-item" title="WhatsApp">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </a>
                <a href="mailto:busdev@bertsolution.com" class="contact-item" title="Email">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </a>
              </div>
            </div>
            
            <div class="footer-column">
              <h4 class="footer-column-title">Find Us</h4>
              <p class="footer-address">
                LEGALO, 16 Office Park Lt. 10 Unit A<br>
                Jl. T. B. Simatupang No. 16 Kebagusan - Pasar Minggu<br>
                Jakarta Selatan, 12560
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="footer-bottom">
      <div class="footer-container-bottom">
        <p>&copy; Copyright 2025 Bert Solution All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
/* Footer */
.footer-section {
  position: relative;
}

.footer-main {
  background: var(--yellow-soft);
  color: var(--text-dark);
  position: relative;
  overflow: hidden;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-16) var(--space-6);
  position: relative;
  z-index: 2;
}

.footer-container-bottom {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.footer-content {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--space-16);
  align-items: start;
}

.footer-brand {
  position: relative;
}

.footer-logo {
  margin-bottom: var(--space-4);
}

.footer-logo-img {
  height: 80px;
  width: auto;
}

.footer-icon {
  position: absolute;
  left: -370px;
  transform: translateY(-50%);
  z-index: 1;
  opacity: 0.3;
}

.footer-icon-img {
  height: 300px;
  width: auto;
  object-fit: contain;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-12);
}

.footer-column-title {
  font-size: var(--text-lg);
  font-weight: var(--font-bold);
  margin: 0 0 var(--space-4) 0;
  color: var(--text-dark);
}

.footer-link {
  display: block;
  color: var(--text-dark);
  text-decoration: none;
  margin-bottom: var(--space-2);
  transition: color var(--transition-base);
  font-size: var(--text-base);
}

.footer-link:hover {
  color: var(--text-dark-grey);
}

.footer-contact {
  display: flex;
  gap: var(--space-3);
}

.contact-item {
  width: 40px;
  height: 40px;
  background: var(--text-dark);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: all var(--transition-base);
}

.contact-item:hover {
  background: var(--text-dark-grey);
  transform: translateY(-2px);
}

.footer-address {
  font-size: var(--text-base);
  line-height: 1.6;
  color: var(--text-dark);
  margin: 0;
}

.footer-bottom {
  background: var(--text-dark);
  color: white;
  text-align: center;
  padding: var(--space-4) 0;
}

.footer-bottom p {
  margin: 0;
  font-size: var(--text-sm);
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: var(--space-8);
  }
  
  .footer-links {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
  
  .footer-icon {
    display: none;
  }
  
  .footer-container {
    padding: var(--space-12) var(--space-6);
  }
}
</style>